export default {

    coffeeData: {
        windBreaker: "Arbre Brise-Vent",
        horticultureInfo: "Arbre Horticole",
        shadeTree: "Arbre d'Ombre",
        coffeeVariety: "Variété de Café",
        coffeeSpecies: "Espèce de Café",
        updateWindBreaker: "Mettre à jour le type d'arbre brise-vent",
        addWindBreaker: "Ajouter un nouveau type d'arbre brise-vent",
        updateHorticultureInfo: "Mettre à jour le type d'arbre horticole",
        addHorticultureInfo: "Ajouter un nouveau type d'arbre horticole",
        updateShadeTree: "Mettre à jour le type d'arbre d'ombre",
        addShadeTree: "Ajouter un nouveau type d'arbre d'ombre",
        updateCoffeeVariety: "Mettre à jour le type de variété de café",
        addCoffeeVariety: "Ajouter une nouvelle variété de café",
        deleteVarietyTitle: "Supprimer la variété",
        deleteVarietyMessage: "Êtes-vous sûr de vouloir supprimer la variété ?",
        updateCoffeeSpecie: "Mettre à jour l'espèce de café",
        deleteSpecieTitle: "Supprimer l'espèce",
        deleteSpecieMessage: "Êtes-vous sûr de vouloir supprimer l'espèce ?",
        addCoffeeSpecie: "Ajouter une nouvelle variété de café",
        variety: "Variété",
        selectVariety: "Sélectionner l'espèce",
        selectSpecie: "Sélectionner l'espèce",
        deleteCoffeeRecord: "Êtes-vous sûr de vouloir supprimer l'enregistrement ?",
        deleteCoffeeData: "Supprimer les données de café",
        topicRequired: "La sélection du sujet est obligatoire",
        coffeeAddSuccess: "Espèce de café ajoutée avec succès.",
        treeTypeSuccess: "Type d'arbre ajouté avec succès.",
        treeTypeUpdateSuccess: "Type d'arbre mis à jour avec succès.",
        coffeeVarietySuccess: "Variété de café ajoutée avec succès.",
        coffeeSpecieSuccess: "Espèce de café mise à jour avec succès.",
        nameRequired: "Le nom est obligatoire",
        notFound: "Aucune donnée d'admin de café trouvée",
    },
    cacaoData: {
        cacao: "Cacao",
        cacaoVariety: "Variété de cacao",
        cacaoSpecies: "Espèce de cacao",
        cacaoWeight: "Poids du cacao",
        cacaoOverview: "Aperçu du cacao",
        buysellOverview: "Aperçu des achats/ventes",
        cacaoType: "Type de cacao",
        deleteCacaoData: "Supprimer les données du cacao",
        productWeight: "Poids du produit",
        productType: "Type de produit",
        productPricePerKg: "Prix par KG",
        registerFermentation: "Enregistrer la fermentation",
        batchVisualIdentification: "Identification visuelle du lot",
        initialWeight: "Poids initial",
        finalWeight: "Poids final",
        performance: "Performance",
        fermentationPercentage: "Pourcentage de fermentation",
        fermetationMethod: "Méthode de fermentation",
        boxes: "Boîtes",
        piles: "Tas",
        bags: "Sacs",
        selectZone: "Sélectionner la zone",
        selectPlantation: "Sélectionner la plantation",
        deliveryMethod: "Méthode de livraison",
        totalPrice: "Prix total",
      },
    memberDataSection: {
        import: "Importer",
        buyingStation: "Station d'achat",
        factory: "Usine",
        factories: "Usines",
        societies: "Sociétés",
        factoryInfo: "Info Usine",
        continue: "Continuer",
        farmerId: "ID Agriculteur",
        farmerName: "Nom de l'Agriculteur",
        farmerAddress: "Adresse de l'Agriculteur",
        quality: "Qualité",
        quantity: "Quantité",
        importAll: "Tout importer",
        importSelected: "Importer sélectionné",
        fileLoaded: "Fichier chargé avec succès",
        incorrectHeaders: "En-têtes incorrects",
        processingBatch: "Traitement du lot",
        purchaseOrder: "Bon de commande",
        buyingStationDetails: "Détails du Poste d'Achat",
        buyingStationUsers: "Utilisateurs du Poste d'Achat",
        activityLog: "Journal d'Activité",
        startDate: "Date de début",
        endDate: "Date de fin",
        purchasingOrder: "Ordre d'achat",
        totalCoffeeCherry: "Total des cerises de café",
        airHumidity: "Humidité de l'air",
        density: "Densité",
        temperature: "Température",
        beanMoistureContent: "Teneur en humidité des grains",
        processType: "Type de processus",
        batchRating: "Sélectionner la note du lot",
        purchaseDate: "Date d'achat",
        selectFarmer: "Sélectionner l'agriculteur",
        selectFarmers: "Sélectionner les agriculteurs",
        selectFarm: "Sélectionner la ferme",
        selectPlantation: "Sélectionner la plantation",
        coffeeVariety: "Variété de café",
        coffeeSpecies: "Espèce de café",
        coffeeCherryQuantity: "Quantité de cerises de café",
        coffeeCherryQuality: "Qualité des cerises de café",
        coffeeType: "Type de café",
        pricePerKg: "Prix par kg",
        processingDone: "Traitement effectué",
        processedCoffeeOut: "Café traité sortant",
        farmer: "Agriculteur",
        farm: "Ferme",
        plantation: "Plantation",

        farmers: "Agriculteurs",
        farmLimitUsed: "Limite de la ferme utilisée",
        phoneNumber: "Numéro de téléphone",
        farmSize: "Taille de la ferme",
        farmLocation: "Ferme/Localisation",
        date: "Date",
        status: "Statut",
        noFarmers: "Aucun agriculteur trouvé",
        approveReject: "Approuver/Rejeter",
        farms: "Fermes",
        crops: "Cultures",
        equipment: "Équipement",
        noFarms: "Aucune ferme trouvée",
        views: "Voir",
        selectStatus: "Sélectionner le statut",
        approved: "Approuvé",
        rejected: "Rejeté",
        reject: "Rejeter",
        approve: "Approuver",
        cancel: "Annuler",
        add: "Ajouter",
        describeYourReason: "Décrivez votre raison ici",
        userInformation: "Informations de l'utilisateur",
        userFarmRequest: "Demande de ferme de l'utilisateur",
        userFarmInformation: "Informations sur la ferme de l'utilisateur",
        activity: "Activité",
        activityType: "Type d'activité",
        farmZone: "Zone de ferme",
        farmerView: "Vue de l'agriculteur",
        cropType: "Type de culture",
        cropVarity: "Variété de culture",
        area: "Superficie",
        cost: "Coût",
        geofence: "Géofence",
        map_views: "Vue de la carte",
        viewAllFarms: "Voir toutes les fermes",
        farmersDetails: "Détails de l'agriculteur",
        download: "Télécharger",
        pOrder: {
            addNew: "Ajouter Nouveau",
            viewAll: "Voir tout",
            selectDate: "Sélectionner une date",
            makeSelection: "Faites une sélection",
            coffeeType: "Type de quantité de café",
            enterPrice: "Entrez le prix",
            reqPurchaseDate: "La date d'achat est obligatoire",
            reqFarmer: "L'agriculteur est obligatoire",
            reqCoffeeQnty: "La quantité de cerises de café est obligatoire",
            reqPrice: "Le prix par kg est obligatoire",
            grandTotal: "TOTAL GÉNÉRAL",
            selectDateRange: "Sélectionner une plage de dates",
            import: "Importer",
            purchaseId: "ID d'achat",
            purchaseDate: "Date d'achat",
            farmerName: "Nom de l'agriculteur",
            quality: "Qualité",
            quantity: "Quantité",
            pricePerKg: "Prix par kg",
            selectBuyingStation: "Sélectionner la station d'achat",
            searchUser: "Rechercher des utilisateurs",
            purchaseListView: "Vue de la liste des achats",
            viewBy: "Voir par",
            typeDensity: "Tapez la densité",
            typeTemperature: "Tapez la température",
            typeWaterContent: "Tapez la teneur en eau",
        },
        farmActivity: "Activité agricole",
        showOnMap: "Afficher sur la carte",
        farmInformation: "Informations sur la ferme",
        dateOfEntry: "Date d'entrée",
        farmID: "ID de la ferme",
        ownershipType: "Type de propriété",
        locationAddress: "Adresse du lieu",
        goalType: "Type d'objectif",
        totalSize: "Taille totale",
        zones: "Zones",
        farmActivities: "Activités agricoles",
        farmDetails: "Détails de la ferme",
        totalFarmsRegistered: "Total des fermes enregistrées",
        totalFarmArea: "Superficie totale de la ferme",
        totalZone: "Zone totale",
        zone: "Zone",

        totalCost: "Coût total",
        selectFarmZone: "Sélectionner une zone/ferme",
        productionType: "Type de production",
        certifications: "Certifications",
        geofences: "Géofences",
        farmsChart: "Graphique des fermes",
        
        // Buying Station specific translations
        buyingStations: "Stations d'Achat",
        registerBuyingStation: "Enregistrer Station d'Achat",
        registerFactory: "Enregistrer Usine",
        loadingFactory: "Chargement de l'Usine...",
        loadingBuyingStation: "Chargement de la Station d'Achat...",
        searchBuyingStation: "Rechercher Station d'Achat",
        searchFactory: "Rechercher Usine",
        searchSociety: "Rechercher Société",
        nameAndId: "Nom / ID",
        email: "Email",
        mobileNumber: "Numéro Mobile",
        role: "Rôle",
        actions: "Actions",
        view: "Voir",
        edit: "Modifier",
        activate: "Activer",
        deactivate: "Désactiver",
        operator: "Opérateur",
        supplier: "Fournisseur",
        active: "Actif",
        deactivated: "Désactivé",
        activatedSuccessfully: "Station d'achat activée avec succès",
        deactivatedSuccessfully: "Station d'achat désactivée avec succès",
        factoryActivatedSuccessfully: "Usine activée avec succès",
        factoryDeactivatedSuccessfully: "Usine désactivée avec succès",
        factoryRegisteredSuccessfully: "Usine enregistrée avec succès",
        deletedSuccessfully: "Station d'achat supprimée avec succès",
        duplicatedSuccessfully: "Station d'achat dupliquée avec succès",
        selectFarms: "Sélectionner des Exploitations",
        reviewSelection: "Réviser la Sélection",
        next: "Suivant",
        reviewMappingPrompt: "Vous avez sélectionné {count} exploitation(s). Confirmez pour les associer à cette station d'achat.",
        confirmMapping: "Confirmer l'Association",
        farmsMappedSuccess: "Exploitations associées avec succès",
        farmsMappedError: "Échec de l'association des exploitations",
        owner: "Propriétaire",
        confirmDialog: {
            delete: {
                title: "Supprimer Station d'Achat",
                message: "Êtes-vous sûr de vouloir supprimer cette station d'achat?",
                confirmBtn: "Supprimer",
            }
        },
        registerNewFactory: "Enregistrer Nouvelle Usine",
        selectHowYouWantToProceed: "Sélectionnez comment vous souhaitez procéder",
        single: "Unique",
        multiple: "Multiple",
        user: "Utilisateur",
        createNewFactory: "Créer une Nouvelle Usine",
        factoryName: "Nom de l'Usine",
        factoryNumber: "Numéro d'Usine",
        buyingStationOrder: {
            bulkImport: {
                importBulkData: "Importer des données en masse",
                importButton: "Importer des bons de commande en masse",
                importButtonCherry: "Importer la Collecte de Cerises en Masse",
                title: "Importation groupée des données de bons de commande",
                titleCherry: "Importation en Masse des Données de Collecte de Cerises",
                // Upload tab
                templateNote: "Téléchargez et utilisez les modèles ci-dessous pour importer des bons de commande en masse.",
                selectTemplate: "Sélectionner un Modèle",
                templateXls: "Importer au Format XLS",
                downloadXls: "Télécharger au Format XLS",
                selectFile: "Sélectionner le fichier pour Télécharger les Données",
                dropHere: "ou glisser-déposer ici",
                fileUploaded: "Le fichier a été téléchargé avec succès.",
                importantNote: "Note Importante",
                importantNoteDetail:
                    "Veuillez utiliser les modèles fournis ci-dessus pour les importations groupées. D'autres formats entraîneront un échec.",
                unsupportedFileFormat: "Ce format de fichier n'est pas pris en charge.",
                invalidFileFormat: "Veuillez télécharger un fichier .xlsx, .xls ou .csv valide en utilisant le modèle fourni.",
                templateErrorIntro:
                    "Le fichier téléchargé ne correspond pas au modèle requis. Téléchargez le modèle et réessayez.",
                importingTitle: "Importation...",
                importingNote:
                    "Vos fichiers téléchargés sont en cours de traitement.\nNous vous informerons une fois les fichiers téléchargés avec succès.",
                // Result page
                importCompleted: "Importation Terminée",
                recordsReadyToImport: "enregistrements prêts à être importés",
                tabTotalRecords: "Total des Enregistrements",
                tabSuccess: "Réussite",
                tabIssues: "Problèmes",
                filterAll: "Tous",
                filterSuccess: "Réussite",
                issuesDetected: "Problèmes Détectés",
                issuesDetectedHeading: "Divergence détectée :",
                issuesDetectedDescription:
                    "Certaines lignes présentent des problèmes de données (p. ex., date d'achat invalide, agriculteur, ferme ou données de café inconnus). Veuillez les vérifier et les résoudre avant la soumission finale.",
                deleteRowsWithIssues: "Supprimer les lignes présentant des divergences de données",
                // Table headers
                purchaseDate: "Date d'achat",
                farmer: "Agriculteur",
                farm: "Ferme",
                buyingStation: "Station d'achat",
                coffeeQuantityQuality: "Quantité et qualité du café",
                plantation: "Plantation",
                coffeeSpecies: "Espèce de café",
                coffeeVariety: "Variété de café",
                coffeeType: "Type de café",
                coffeeCherryQuantity: "Quantité de cerises de café",
                coffeeCherryQuality: "Qualité des cerises de café",
                pricePerKg: "Prix par kg",
                receiptNo: "Numéro de reçu",
                lotId: "ID du Lot",
                photos: "Photos",
                // Actions / dialogs
                purchaseOrder: "Bon de commande",
                detailsTitle: "Détail du bon de commande",
                editRecord: "Modifier l'enregistrement",
                deleteRecord: "Supprimer l'enregistrement",
                deleteRecordConfirm:
                    "Êtes-vous sûr de vouloir supprimer cet enregistrement ? Cette action est irréversible.",
                deleteDiscrepancyConfirm:
                    "Êtes-vous sûr de vouloir supprimer toutes les {count} ligne(s) présentant des problèmes ? Cette action est irréversible.",
                cancelImportTitle: "Annuler l'Importation",
                cancelImportConfirm:
                    "Êtes-vous sûr de vouloir annuler cette importation ? Les enregistrements validés ne pourront plus être importés.",
                cancelImportConfirmBtn: "Annuler l'Importation",
                importConfirm: "Importer {count} enregistrement(s) valide(s) maintenant ?",
                recordUpdatedSuccess: "Enregistrement mis à jour avec succès.",
                recordsDeletedSuccess: "Enregistrements supprimés avec succès.",
                importCancelledSuccess: "Importation annulée avec succès.",
                genericError: "Une erreur s'est produite. Veuillez réessayer.",
                noDataFound: "Aucune donnée trouvée.",
                // Edit dialog
                selectFactory: "Sélectionner l'usine",
                selectFarmer: "Sélectionner l'agriculteur",
                selectFarm: "Sélectionner la ferme",
                selectPlantation: "Sélectionner la plantation",
                submit: "Soumettre",
                addImage: "Ajouter une image",
                addedBy: "Ajouté par",
                close: "Fermer",
                // Success dialog
                successDialogTitle: "Message de Réussite",
                importedSuccessfully: "{count} bon(s) de commande ont été importés avec succès.",
                // History
                historyFile: "Nom du Fichier",
                historyImportedOn: "Importé Le",
                historyEmpty: "Aucun historique d'importation groupée pour le moment.",
                statusValidating: "Validation",
                statusSuccess: "Importé",
                statusCancelled: "Annulé",
                // Error-code labels (tooltips / field messages)
                errorInvalidPurchaseDate: "La date d'achat est invalide.",
                errorMissingPurchaseDate: "La date d'achat est manquante.",
                errorMissingMemberId: "L'identifiant membre est manquant.",
                errorInvalidMemberIdFormat: "Le format de l'identifiant membre est invalide. Attendu : Nom de l'agriculteur - Nom de la station d'achat - ID de ferme.",
                errorInvalidFarmerName: "L'agriculteur n'a pas été trouvé dans votre organisation.",
                errorInvalidBuyingStationName: "La station d'achat n'a pas été trouvée dans votre organisation.",
                errorInvalidFarm: "La ferme n'a pas été trouvée dans votre organisation.",
                errorMissingQuantity: "La quantité de cerises de café est manquante.",
                errorInvalidQuantity: "La quantité de cerises de café doit être un nombre supérieur à zéro.",
                errorMissingQuality: "La qualité des cerises de café est manquante.",
                errorInvalidQuality: "La qualité des cerises de café n'a pas été reconnue.",
                errorMissingPrice: "Le prix est manquant.",
                errorInvalidPrice: "Le prix doit être un nombre valide.",
                // Filter chip short labels
                chipInvalidPurchaseDate: "Date d'achat invalide",
                chipMissingPurchaseDate: "Date d'achat manquante",
                chipMissingMemberId: "Identifiant membre manquant",
                chipInvalidMemberIdFormat: "Format d'identifiant membre invalide",
                chipInvalidFarmerName: "Agriculteur invalide",
                chipInvalidBuyingStationName: "Station d'achat invalide",
                chipInvalidFarm: "Ferme invalide",
                chipMissingQuantity: "Quantité manquante",
                chipInvalidQuantity: "Quantité invalide",
                chipMissingQuality: "Qualité manquante",
                chipInvalidQuality: "Qualité invalide",
                chipMissingPrice: "Prix manquant",
                chipInvalidPrice: "Prix invalide",

            },
        },
        processingBatchBulkImport: {
            bulkImport: "Importer des Lots de Traitement en Masse",
            title: "Importation Groupée des Lots de Traitement",
            instructions: "Téléchargez un fichier CSV ou XLSX en utilisant le modèle ci-dessous. Chaque ligne crée un lot de traitement.",
            downloadCsv: "Télécharger le modèle CSV",
            downloadXlsx: "Télécharger le modèle XLSX",
            selectFile: "Sélectionner un fichier CSV ou XLSX",
            rowsParsed: "{count} ligne(s) prête(s) à importer.",
            import: "Importer",
            imported: "{created} sur {total} lot(s) importé(s).",
            failed: "{failed} ligne(s) échouée(s).",
            rowError: "Ligne {row}",
            emptyFile: "Le fichier ne contient aucune ligne de données.",
            missingColumns: "Colonne(s) requise(s) manquante(s) : {columns}",
            noBuyingStation: "Aucune station d'achat sélectionnée.",
            validating: "Validation des lignes…",
            total: "Total",
            valid: "Valide",
            invalid: "Invalide",
            all: "Tout",
            statusValid: "Valide",
            statusInvalid: "Invalide",
            issues: "Problèmes",
            back: "Retour",
            importValid: "Importer {count} ligne(s) valide(s)",
            done: "Terminé",
            rowCol: "Ligne",
            startDateCol: "Date de Traitement",
            purchaseOrdersCol: "Codes d'Achat",
            processTypeCol: "Type de Traitement",
            gradeCol: "Grade",
            seasonCol: "Saison",
            statusCol: "Statut",
            purchaseDateCol: "Date d'Achat",
            processDateCol: "Date de Traitement",
            parchmentCol: "Parche (Kg)",
            bagsCol: "Sacs",
            vehiclePlateCol: "Plaque du Véhicule",
            harvestedCol: "Récolté",
            pulpedCol: "Dépulpé",
            washedCol: "Lavé",
            dryingStartedCol: "Séchage Commencé",
            movedToStoreCol: "Transféré au Dépôt",
            templateNote: "Téléchargez et utilisez les modèles ci-dessous pour importer des lots de traitement en masse.",
            selectTemplate: "Sélectionner un Modèle",
            templateCsv: "Format d'Import CSV",
            templateXls: "Format d'Import XLS",
            downloadCsvFormat: "Télécharger le Format CSV",
            downloadXls: "Télécharger le Format XLS",
            importingTitle: "Importation Groupée des Lots de Traitement",
            importingNote: "Votre fichier téléchargé est en cours de traitement.\nNe cliquez pas sur annuler, ne fermez pas et ne rafraîchissez pas cette page pour éviter toute interruption.",
            importantNote: "Note Importante",
            importantNoteDetail: "Veuillez utiliser les modèles fournis ci-dessus pour l'importation groupée des lots de traitement. D'autres formats entraîneront un échec.",
            invalidFileFormat: "Veuillez télécharger un fichier .csv, .xlsx ou .xls valide en utilisant le modèle fourni.",
            unsupportedFileFormat: "Ce format de fichier n'est pas pris en charge.",
            templateErrorIntro: "Le fichier téléchargé ne correspond pas au modèle requis. Téléchargez le modèle et réessayez.",
            importCompleted: "Importation Terminée",
            tabTotalRecords: "Total des Enregistrements",
            tabSuccess: "Succès",
            tabIssues: "Problèmes",
            filterAll: "Tout",
            filterSuccess: "Succès",
            issuesDetected: "Problèmes Détectés",
            issuesDetectedHeading: "Problèmes Détectés :",
            issuesDetectedDescription: "Certaines lignes présentent des problèmes de données (ex. : dates manquantes, type de traitement inconnu, valeur de parche invalide). Veuillez les examiner et les résoudre avant la soumission finale.",
            deleteRowsWithIssues: "Supprimer les lignes avec des problèmes",
            editRecord: "Modifier l'enregistrement",
            deleteRecord: "Supprimer l'enregistrement",
            deleteRecordConfirm: "Êtes-vous sûr de vouloir supprimer cet enregistrement ? Cette action est irréversible.",
            deleteDiscrepancyConfirm: "Êtes-vous sûr de vouloir supprimer les {count} ligne(s) avec des problèmes ? Cette action est irréversible.",
            cancelImportTitle: "Annuler l'Importation",
            cancelImportConfirm: "Êtes-vous sûr de vouloir annuler cette importation ? Les enregistrements validés ne pourront plus être importés.",
            cancelImportConfirmBtn: "Annuler l'Importation",
            importConfirm: "Importer {count} enregistrement(s) valide(s) maintenant ?",
            recordUpdatedSuccess: "Enregistrement mis à jour avec succès.",
            recordsDeletedSuccess: "Enregistrements supprimés avec succès.",
            importCancelledSuccess: "Importation annulée avec succès.",
            genericError: "Une erreur s'est produite. Veuillez réessayer.",
            noDataFound: "Aucune donnée trouvée.",
            editRecordTitle: "Modifier l'Enregistrement",
            submit: "Soumettre",
            detailsTitle: "Détails du Lot de Traitement",
            close: "Fermer",
            successDialogTitle: "Message de Succès",
            importedSuccessfully: "{count} lot(s) de traitement importé(s) avec succès.",
            historyFile: "Nom du Fichier",
            historyImportedOn: "Importé le",
            historyEmpty: "Aucun historique d'importation groupée.",
            statusValidating: "Validation",
            statusSuccess: "Importé",
            statusCancelled: "Annulé",
            errorCodePurchaseDateRequired: "La date d'achat est obligatoire.",
            errorCodeInvalidPurchaseDate: "Le format de la date d'achat n'est pas reconnu.",
            errorCodeProcessDateRequired: "La date de traitement est obligatoire.",
            errorCodeInvalidProcessDate: "Le format de la date de traitement n'est pas reconnu.",
            errorCodeUnknownProcessType: "Le type de traitement n'est pas reconnu.",
            errorCodeNoOrdersForDate: "Aucun bon de commande trouvé pour la date d'achat indiquée.",
            errorCodeParchmentInvalid: "La valeur de parche (Kg) est invalide.",
            errorCodeParchmentExceedsCherry: "Le parche (Kg) ne peut pas dépasser la quantité totale de cerises de café.",
            errorCodeInvalidData: "Un ou plusieurs champs contiennent des données invalides.",
            chipPurchaseDateRequired: "Date d'Achat Requise",
            chipInvalidPurchaseDate: "Date d'Achat Invalide",
            chipProcessDateRequired: "Date de Traitement Requise",
            chipInvalidProcessDate: "Date de Traitement Invalide",
            chipUnknownProcessType: "Type de Traitement Inconnu",
            chipNoOrdersForDate: "Aucun Bon pour cette Date",
            chipParchmentInvalid: "Parche Invalide",
            chipParchmentExceedsCherry: "Parche Dépasse les Cerises",
            chipInvalidData: "Données Invalides",
        },
        greenCoffee: {
            bulkImport: {
                importButton: "Importer le Café Vert en Masse",
                title: "Importation Groupée des Données de Café Vert",
                breadcrumb: "Aperçu du Café > Décorticage à Sec",
                tabImport: "Importer",
                tabHistory: "Historique",
                templateNote:
                    "Téléchargez et utilisez les modèles ci-dessous pour importer le café vert en masse.",
                selectTemplate: "Sélectionner un Modèle",
                templateXls: "Importer au Format XLS",
                importingTitle: "Importation Groupée des Données de Café Vert",
                importingNote:
                    "Votre fichier téléchargé est en cours de traitement.\nNe cliquez pas sur annuler, ne fermez pas et n'actualisez pas cette page pour éviter toute interruption.",
                importCompleted: "Importation Terminée",
                tabTotalRecords: "Total des Enregistrements",
                tabSuccess: "Réussite",
                tabFailed: "Échoués",
                tabIssues: "Problèmes",
                tabDataDiscrepancies: "Divergences de Données",
                filterAll: "Tous",
                filterSuccess: "Réussite",
                filterIssues: "Problèmes",
                issuesDetectedHeading: "Problèmes Détectés :",
                issuesDetectedDescription:
                    "Certains lots présentent des problèmes de données (p. ex., numéro de production invalide, numéro de production inexistant dans le système). Veuillez les vérifier et les résoudre avant la soumission finale.",
                deleteLotsWithDataDiscrepancies: "Supprimer les Lots avec Divergences de Données",
                lotId: "ID du Lot",
                lotIdAndOutturn: "ID du Lot et Production",
                grower: "Producteur",
                coffeeType: "Type de Café",
                grossAndNetWeight: "Poids Brut et Poids Net",
                issuesDetected: "Problèmes Détectés",
                issueOutturnNumberMismatchTitle: "Non-concordance du numéro de production :",
                issueOutturnNumberMismatchDescription:
                    "Cette production ne correspond à aucun enregistrement de Livraison de Parche existant. Veuillez vous assurer que le Numéro de Production a été lié manuellement au niveau de l'Usine avant de recharger.",
                issueDuplicateOutturnNumberTitle: "Numéro de Production en Double :",
                issueDuplicateOutturnNumberDescription:
                    "Le numéro de production apparaît plusieurs fois dans ce document téléchargé.",
                issueMissingOutturnNumberTitle: "Numéro de Production Manquant :",
                issueMissingOutturnNumberDescription:
                    "La ligne téléchargée ne contient pas de Numéro de Production. Un identifiant de Production unique et valide est requis pour faire correspondre l'enregistrement au système de l'usine.",
                issueGrowerIdentityMismatchTitle: "Non-concordance de l'Identité du Producteur :",
                issueGrowerIdentityMismatchDescription:
                    "Le numéro de production est enregistré dans notre système sous le Producteur {mobileGrowerName}, mais le fichier téléchargé l'attribue à {xlsGrowerName}. Écrasement des données restreint.",
                issueMissingGrowerCredentialsTitle: "Identifiants du Producteur Manquants :",
                issueMissingGrowerCredentialsDescription:
                    "L'enregistrement ne contient pas le Nom du Producteur ou l'ID du Producteur. Ces champs de données sont obligatoires pour vérifier la propriété de l'usine avant que le lot puisse être rapproché.",
                editRecord: "Modifier l'enregistrement",
                deleteRecord: "Supprimer l'enregistrement",
                downloadXls: "Télécharger au Format XLS",
                selectFile: "Sélectionner le fichier pour Télécharger les Données",
                dropHere: "ou glisser-déposer ici",
                importantNote: "Note Importante",
                importantNoteDetail:
                    "Veuillez utiliser les modèles fournis ci-dessus pour importer le café vert en masse. D'autres formats entraîneront un échec.",
                invalidFileFormat: "Veuillez télécharger un fichier .xlsx ou .xls valide en utilisant le modèle fourni.",
                unsupportedFileFormat: "Ce format de fichier n'est pas pris en charge.",
                importFailed: "Échec de l'Importation",
                importFailedIntro:
                    "Le fichier n'a pas pu être importé. Vérifiez le format du modèle et les données des lignes, puis réessayez.",
                templateErrorIntro:
                    "Le fichier téléchargé ne correspond pas au modèle requis. Téléchargez le modèle XLS et réessayez.",
                tryAgain: "Réessayer",
                errorDetails: "Détails",
                historyEmpty: "Aucun historique d'importation groupée pour le moment.",
                // Validation review / import flow
                validationSummaryTitle: "Résumé de la Validation",
                recordsReadyToImport: "enregistrements prêts à être importés",
                editRecordTitle: "Modifier l'Enregistrement",
                growerCode: "Code du Producteur",
                growerName: "Nom du Producteur",
                greenBeansTotal: "Poids d'Entrée Avec Sacs (Kgs)",
                selectedCount: "sélectionné(s)",
                deleteSelected: "Supprimer la Sélection",
                deleteRecordConfirm:
                    "Êtes-vous sûr de vouloir supprimer cet enregistrement ? Cette action est irréversible.",
                deleteSelectedConfirm:
                    "Êtes-vous sûr de vouloir supprimer les {count} enregistrement(s) sélectionné(s) ? Cette action est irréversible.",
                deleteDiscrepancyConfirm:
                    "Êtes-vous sûr de vouloir supprimer tous les {count} lot(s) présentant des divergences de données ? Cette action est irréversible.",
                cancelImportTitle: "Annuler l'Importation",
                cancelImportConfirm:
                    "Êtes-vous sûr de vouloir annuler cette importation ? Les enregistrements validés ne pourront plus être importés.",
                cancelImportConfirmBtn: "Annuler l'Importation",
                importConfirm: "Importer {count} enregistrement(s) valide(s) maintenant ?",
                recordUpdatedSuccess: "Enregistrement mis à jour avec succès.",
                recordsDeletedSuccess: "Enregistrements supprimés avec succès.",
                importCancelledSuccess: "Importation annulée avec succès.",
                importSuccess: "Importation terminée avec succès.",
                genericError: "Une erreur s'est produite. Veuillez réessayer.",
                // Issue / error-code labels
                issueInvalidDataTitle: "Données Invalides :",
                issueInvalidDataDescription:
                    "Un ou plusieurs champs contiennent des données invalides. Veuillez les vérifier et les corriger.",
                errorCodeOutturnMismatch:
                    "Ce numéro de production ne correspond à aucun enregistrement de livraison de parche existant.",
                errorCodeOutturnMissing: "Le numéro de production est manquant.",
                errorCodeOutturnDuplicate:
                    "Ce numéro de production est en double dans le fichier ou existe déjà dans le système.",
                errorCodeGrowerMismatch:
                    "Le nom/code du producteur ne correspond pas à la livraison de parche enregistrée.",
                errorCodeGrowerMissing: "Le nom ou le code du producteur est manquant.",
                errorCodeInvalidData: "Un ou plusieurs champs contiennent des données invalides.",
                // History table
                historyFile: "Nom du Fichier",
                historyImportedOn: "Importé Le",
                historyUploadedBy: "Téléchargé Par",
                historyCreatedDate: "Date de Création",
                historyTotalRecords: "Total des Enregistrements",
                historyErrorRecords: "Enregistrements en Erreur",
                // Bulk import status labels
                statusValidating: "Validation",
                statusSuccess: "Importé",
                statusCancelled: "Annulé",
                // Edit record dialog
                editFieldId: "ID",
                inputWeightWithBags: "Poids d'Entrée Avec Sacs",
                qualityControl: "Contrôle Qualité",
                submit: "Soumettre",
                noMillingOutputs: "Aucun détail de sortie de décorticage.",
                millingCleanCoffee: "Café Propre (Détails de Sortie de Décorticage)",
                millingBags: "Sacs (Détails de Sortie de Décorticage)",
                millingPockets: "Poches (Détails de Sortie de Décorticage)",
                millingWeight: "Poids (Détails de Sortie de Décorticage)",
                millingBulkOutturn: "Production en Vrac (Détails de Sortie de Décorticage)",
                millingRatio: "Ratio (Détails de Sortie de Décorticage)",
                // Detail dialog
                detailsTitle: "Détails du Café Vert",
                outturnNo: "N° de Production",
                close: "Fermer",
                // Success dialog
                successDialogTitle: "Message de Réussite",
                importedSuccessfully:
                    "{count} enregistrement(s) de café vert ont été importés avec succès.",
                // Filter chip short labels (per error category)
                chipOutturnMismatch: "Non-concordance du Numéro de Production",
                chipOutturnMissing: "Numéro de Production Manquant",
                chipOutturnDuplicate: "Numéro de Production en Double",
                chipGrowerMismatch: "Non-concordance de l'Identité du Producteur",
                chipGrowerMissing: "Identifiants du Producteur Manquants",
                chipInvalidData: "Données Invalides",
            },
            processGreenCoffee: "Traiter le Café Vert",
            addedBy: "Ajouté par",
            selectProductType: "Sélectionner le Type de Produit",
            processDate: "Date de Traitement",
            selectProcessingBatch: "Sélectionner le Lot de Traitement",
            lotIdAndDate: "ID du Lot et Date",
            typeAndQuantity: "Type et Quantité",
            supplier: "Fournisseur",
            outturnNumber: "Numéro de Production",
            totalInputQuantity: "Quantité Totale d'Entrée (kg)",
            qualityControl: "Contrôle Qualité",
            airHumidity: "Humidité de l'Air (valeur en %)",
            density: "Densité (kg/cm3)",
            greenCoffeeQualityScore: "Score de Qualité du Café Vert",
            batchProduction: "Production du Lot",
            unsortedGreenBeans: "Grains Verts Non Triés (kg)",
            batchProductionDensity: "Densité de Production du Lot (kg/cm3)",
            percentagePrimaryDefect: "Pourcentage de Défaut Primaire",
            percentageSecondaryDefect: "Pourcentage de Défaut Secondaire",
            greenBeans: "Grains Verts",
            totalGreenBeans: "Total des Grains Verts (kg)",
            unitSize: "Taille de l'Unité (kg)",
            totalBags: "Total des Sacs",
            leftoverQuantity: "Quantité Restante",
            leftoverQuantityDesc: "La Quantité Restante est le montant restant qui ne peut pas former un sac complet. Elle représente la quantité restante après avoir rempli le nombre maximal d'unités complètes à partir de l'approvisionnement total.",
            expiryDate: "Date d'Expiration",
            label: "Étiquette",
            qualityControlButton: "Contrôle Qualité",
            valueInPercent: "valeur en %",
            kgCm3: "kg/cm3",
            complete: "Terminé",
            lotIdOutturnNo: "ID du Lot / N° de Production",
            startDate: "Date de Début",
            greenBeansQualityGrading: "Classement de Qualité des Grains Verts",
            totalQuantity: "Quantité Totale",
            quantity: "Quantité",
            packing: "Emballage",
            bag: "Sac",
            qualityScore: "Score de Qualité",
            noLotsYet: "Aucun lot pour le moment. Ajoutez des classements de qualité depuis le flux de création.",
            lotId: "ID du Lot",
            percentage: "Pourcentage",
            createQualityGrade: "Créer un Classement de Qualité",
            finishGrading: "Terminer le Classement",
            finishGradingDesc: "Une fois terminé, vous ne pourrez plus classer ce lot. Le gaspillage sera calculé automatiquement après l'achèvement.",
            finishGradingButton: "Terminer le Classement",
            addNewQualityGrade: "Ajouter un Nouveau Classement de Qualité",
            totalGreenBeansExceeded: "La quantité totale classée ne peut pas dépasser le total des grains verts",
            lotIdAlreadyExists: "Cet ID de lot est déjà utilisé. Utilisez un ID de lot différent.",
            toAddRecord: "pour ajouter un enregistrement.",
            registeredSuccess: "Café vert enregistré avec succès",
            exportNotImplemented: "Exportation non implémentée",
            processingBatchRequired: "Le lot de traitement est obligatoire",
            outturnAvailable: "Le numéro de production est disponible",
            outturnExists: "Ce numéro de production existe déjà. Veuillez en saisir un unique.",
            totalGreenBeansRequired: "Le total des grains verts est obligatoire",
            enterHere: "Saisir ici",
            viewTitle: "Classement de Qualité des Grains Verts",
            parchmentInformation: "Informations sur la Parche",
            processInformation: "Informations sur le Processus",
            greenBeansInformation: "Informations sur les Grains Verts",
            traceabilityLabel: "Étiquette de Traçabilité",
            waste: "Gaspillage",
            downloadLabel: "Télécharger l'Étiquette",
            startCupping: "Démarrer la Dégustation",
            cuppingHistory: "Historique de Dégustation",
            noDataFound: "Aucune donnée trouvée.",
            noParchmentBatches: "Aucun lot de parche lié.",
            noQualityGrades: "Aucun classement de qualité enregistré.",
            batchId: "ID du Lot",
            species: "Espèce",
            variety: "Variété",
            process: "Processus",
            batchRating: "Note du Lot",
            humidity: "Humidité",
            totalCoffeeCherryQty: "Quantité Totale de Cerises",
            weightBeforeProcessing: "Poids avant Traitement",
            numberOfBags: "Nombre de Sacs",
            externalId: "ID Externe",
            qrCode: "Code QR",
            latestCuppingScore: "Dernier Score de Dégustation",
            totalWaste: "Gaspillage Total",
            close: "Fermer",
            unitSizeKgBag: "Taille de l'Unité (kg/sac)",
            grade: "Classement",
            selectGrade: "Sélectionner le classement",
            quantityRequired: "La quantité est obligatoire",
            quantityMustBePositive: "La quantité doit être supérieure à 0",
            unitSizeRequired: "La taille de l'unité est obligatoire",
            unitSizeMustBePositive: "La taille de l'unité doit être supérieure à 0",
            gradeRequired: "Le classement est obligatoire",
            labelRequired: "L'étiquette est obligatoire",
            cupping: "Dégustation",
            cuppingInformation: "Informations sur la Dégustation",
            cupperName: "Nom du Dégustateur",
            cuppingDate: "Date de Dégustation",
            enterCupperName: "Saisir le nom du dégustateur",
            attachFiles: "Joindre des Fichier(s)",
            selectFilesToUpload: "Sélectionner des Fichier(s) pour Télécharger les Données",
            orDragAndDrop: "ou glisser-déposer ici",
            lightRoast: "Torréfaction Légère",
            roastingTime: "Temps de Torréfaction",
            roastingTemperature: "Température de Torréfaction",
            qualities: "Qualités",
            uniformity: "Uniformité",
            cleanCup: "Tasse Propre",
            sweetness: "Douceur",
            overall: "Global",
            defects: "Défauts",
            finalScore: "Score Final",
            sessionDetails: "Détails de la session",
            noCuppingHistory: "Aucun historique de dégustation pour ce café vert.",
            cuppingDataSaved: "Données de dégustation enregistrées.",
            date: "Date",
            roast: "Torréfaction",
            score: "Score",
        },
    },
}
